// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".card[data-v-ed90998e]{--tw-bg-opacity:1;background-color:#1a2035;background-color:rgb(26 32 53/var(--tw-bg-opacity));border-radius:.5rem}.card-footer[data-v-ed90998e],.card-header[data-v-ed90998e]{--tw-bg-opacity:1;background-color:#1e243e;background-color:rgb(30 36 62/var(--tw-bg-opacity))}.card-body[data-v-ed90998e],.card-footer[data-v-ed90998e],.card-header[data-v-ed90998e]{padding:.75rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
